export default "__VITE_ASSET__BEiFLOG$__"